import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const getStyleByType = (type?: string) => {
  switch (type) {
    case 'account':
      return {
        top: 'unset',
        left: 'unset',
        'margin-left': `${650 * Screen.widthRatio}px`,
        'margin-top': `${0 * Screen.widthRatio}px`,
        height: `${80 * Screen.widthRatio}px`,
        width: `${80 * Screen.widthRatio}px`,
      };
    case 'logout':
      return {
        top: 'unset',
        left: 'unset',
        'margin-top': `${50 * Screen.widthRatio}px`,
        'margin-left': `${100 * Screen.widthRatio}px`,
      };
    case 'network':
      return {
        top: '76%',
      };
  }
};

const SpinnerContainer = styled.div<{ type?: string }>`
  animation: rotate 1s infinite linear;
  height: ${100 * Screen.widthRatio}px;
  left: 50%;
  margin-top: ${-50 * Screen.widthRatio}px;
  margin-left: ${-50 * Screen.widthRatio}px;
  position: fixed;
  top: 50%;
  width: ${100 * Screen.widthRatio}px;
  ${(props) => {
    return getStyleByType(props?.type);
  }}

  svg path {
    transition: 0.2s;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default SpinnerContainer;
